"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LEAVE_MS = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _slicedToArray2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _Toast = _interopRequireDefault(require("web/shared/components/Toast"));
var _toast = require("web/shared/utils/toast");
var _ToastHost = require("web/shared/components/ToastHost.styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* The one place toasts appear: a stack near the bottom of the screen,
* over the page and above a phone's tab bar. Registers with `showToast`
* for the app's life; each toast runs its own countdown and exit.
*/ // How long the fade-out plays before a toast unmounts.
const LEAVE_MS = exports.LEAVE_MS = 220; // One live toast: its request plus whether its fade-out is playing.
function ToastHost() {
  const _useState = (0, _react.useState)([]),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    toasts = _useState2[0],
    setToasts = _useState2[1]; // The exit timer per toast, keyed by nonce; cleared on unmount.
  const exitsRef = (0, _react.useRef)(new Map()); // Start a toast's fade-out, then drop it once the fade has played. A
  // toast already leaving is left to finish.
  const dismiss = nonce => {
    if (exitsRef.current.has(nonce)) {
      return;
    }
    setToasts(previous => previous.map(toast => toast.request.nonce === nonce ? (0, _objectSpread2.default)((0, _objectSpread2.default)({}, toast), {}, {
      leaving: true
    }) : toast));
    const timer = setTimeout(() => {
      exitsRef.current.delete(nonce);
      setToasts(previous => previous.filter(toast => toast.request.nonce !== nonce));
    }, LEAVE_MS);
    exitsRef.current.set(nonce, timer);
  }; // The listener is registered once and lives as long as the host, so it
  // reads whichever `dismiss` is current rather than one render's.
  const dismissRef = (0, _react.useRef)(dismiss);
  dismissRef.current = dismiss;
  (0, _react.useEffect)(() => {
    const exits = exitsRef.current;
    (0, _toast.setToastListener)({
      show: request => {
        setToasts(previous => [...previous, {
          request,
          leaving: false
        }]);
      },
      dismiss: nonce => dismissRef.current(nonce)
    });
    return () => {
      (0, _toast.setToastListener)(null);
      for (const timer of exits.values()) {
        clearTimeout(timer);
      }
      exits.clear();
    };
  }, []);
  if (toasts.length === 0) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ToastHost.styles.stack)), {}, {
    children: toasts.map(toast => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Toast.default, {
      request: toast.request,
      leaving: toast.leaving,
      onDismiss: () => dismiss(toast.request.nonce)
    }, toast.request.nonce))
  }));
}
var _default = exports.default = ToastHost;